import { disputeSource } from "@redotech/redo-model/disputes/dispute-definition";
import * as z from "zod/v4";

export const generateCustomerCommunicationEvidence = {
  name: "generateCustomerCommunicationEvidence" as const,
  input: z.object({ disputeId: z.string(), source: z.enum(disputeSource) }),
  output: z.object({
    success: z.boolean(),
    fileUrl: z.string().optional(),
    fileName: z.string().optional(),
    error: z.string().optional(),
  }),
};
